import {Chip} from "@mui/material";
import React, {useContext} from "react";
import SimpleInfoElement from "../../../../../common/components/shared/simpleInfoElement/simpleInfoElement";
import i18n from "../../../../../i18n/i18n";
import Row from "../../../../../common/components/shared/row/row";
import TextInput from "../../../../../common/components/shared/textInput/textInput";
import {storesContext} from "../../../../../common/stores/stores";

interface TemperatureSectionProps {
    type: "entry" | "exit";
    icon: JSX.Element;
    isUpdate: boolean;
}

export default function TemperatureSection(props: TemperatureSectionProps): React.ReactElement {
    const isEntryOrExitTestId = props.type;
    const isEntry = props.type === "entry";
    const tcrStore = useContext(storesContext).tcrStore;

    const requestedTemp1 = tcrStore.requestedTemp1;
    const requestedTemp2 = tcrStore.requestedTemp2;
    const entryActualTemp1 = tcrStore.entryActualTemp1;
    const exitActualTemp1 = tcrStore.exitActualTemp1;
    const entryActualTemp2 = tcrStore.entryActualTemp2;
    const exitActualTemp2 = tcrStore.exitActualTemp2;

    return (
        <div className="section two-sections">
            <div className="section-header">
                {i18n.t("transportation.order.tcr.sections.temperature.header")}
                <Chip
                    className={`tcr-chip ${isEntry ? "tcr-chip-entry" : "tcr-chip-exit"}`}
                    label={isEntry ? i18n.t("orderStatus.DEPO_ENTERED") : i18n.t("orderStatus.DEPO_EXITED")}
                    icon={props.icon}
                    data-testid="temperature-section-chip"
                />
            </div>

            {props.isUpdate ? renderContentModification() : renderContentView()}

        </div>
    );

    function renderContentView() {
        return (
            <div className="section-content">
                {renderRequestTempView()}
                {renderActualView()}
            </div>
        );
    }

    function renderRequestTempView() {
        return (
            <Row class="flex-type gap-20 nowrap">
                <SimpleInfoElement
                    label={i18n.t("transportation.order.tcr.sections.temperature.labels.requestedTemp1")}
                    value={requestedTemp1}
                    unit="°C"
                    testId={`${isEntryOrExitTestId}-requested-temp-one`}
                />
                <SimpleInfoElement
                    label={i18n.t("transportation.order.tcr.sections.temperature.labels.requestedTemp2")}
                    value={requestedTemp2}
                    unit="°C"
                    testId={`${isEntryOrExitTestId}-requested-temp-two`}
                />
            </Row>
        );
    }

    function renderActualView() {
        return (
            <Row class="flex-type gap-20 nowrap">
                <SimpleInfoElement
                    label={i18n.t("transportation.order.tcr.sections.temperature.labels.actualTemp1")}
                    value={isEntry ? entryActualTemp1.value : exitActualTemp1.value}
                    unit="°C"
                    testId={`${isEntryOrExitTestId}-actual-temp-one`}
                />
                <SimpleInfoElement
                    label={i18n.t("transportation.order.tcr.sections.temperature.labels.actualTemp2")}
                    value={isEntry ? entryActualTemp2.value : exitActualTemp2.value}
                    unit="°C"
                    testId={`${isEntryOrExitTestId}-actual-temp-two`}
                />
            </Row>
        );
    }

    function renderContentModification() {
        return (
            <div className="section-content">
                {renderRequestTempView()}
                {renderActualModification()}
            </div>
        );
    }

    function renderActualModification() {
        return (
            <Row class="flex-type gap-20 nowrap">
                <TextInput
                    className="temp-input"
                    validatedValue={isEntry ? entryActualTemp1 : exitActualTemp1}
                    label={i18n.t("transportation.order.tcr.sections.temperature.labels.actualTemp1")}
                    testId={`${isEntryOrExitTestId}-actual-temp-one-input`}
                    unit="°C"
                    onChange={() => {
                        tcrStore.setIsEdit(true);
                    }}
                />
                <TextInput
                    className="temp-input"
                    validatedValue={isEntry ? entryActualTemp2 : exitActualTemp2}
                    label={i18n.t("transportation.order.tcr.sections.temperature.labels.actualTemp2")}
                    testId={`${isEntryOrExitTestId}-actual-temp-two-input`}
                    unit="°C"
                    onChange={() => {
                        tcrStore.setIsEdit(true);
                    }}
                />
            </Row>
        );
    }
}